import { render, staticRenderFns } from "./TemplateListPage.vue?vue&type=template&id=2bf144ac&"
import script from "./TemplateListPage.vue?vue&type=script&lang=js&"
export * from "./TemplateListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports